export const STATUS_SET = 'attendant-login.STATUS_SET'
export const EMAIL_SET = 'attendant-login.EMAIL_SET'
export const PASSWORD_SET = 'attendant-login.PASSWORD_SET'
export const LOADING_SET = 'attendant-login.LOADING_SET'
export const TOKEN_SET = 'Tattendant-login.TOKEN_SET'
export const LOGIN_SET = 'attendant-login.LOGIN_SET'
export const URL_SET = 'attendant-login.URL_SET'
export const ERROR_SET = 'attendant-login.ERROR_SET'
